<div class="position-relative">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img class="d-block w-100" src="https://api.bealign.com/img/contenidos/26.jpg" />
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="https://api.bealign.com/img/contenidos/27.jpg" />
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="https://api.bealign.com/img/contenidos/28.jpg" />
            </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</div>